import { useEffect, type ReactNode } from 'react';
import { stompClient } from '@shared/ws';
import { tokenStorage } from '@shared/api';
import { env } from '@shared/config/env';
import { useSessionStore } from '@entities/session';

export function WsBootstrap({ children }: { children: ReactNode }) {
  const status = useSessionStore((s) => s.status);

  useEffect(() => {
    if (env.mock) return;
    if (status === 'authenticated') {
      stompClient.connect(() => tokenStorage.getAccess());
    } else {
      stompClient.disconnect();
    }
  }, [status]);

  return <>{children}</>;
}
